/* eslint-disable prefer-spread */
/* eslint-disable prefer-rest-params */
/* eslint-disable func-names */
/* global BackboneEx _ */
import { onStateChange as onWebSocketsStateChange } from 'common/websockets';
import channelCodes from 'config/channelCodes';
import { CalendarAnalytics, enableRecording, trackEvent } from 'common/analytics';
import App from 'common/backbone-app';
import moment from '../../../javascripts-es6/common/moment';
import React from 'react';
import ReactDOM from 'react-dom';
import { Reconnect } from 'federation/Reconnect';
import { openInstantSaleCheckout } from 'utilities/open-instant-sale-checkout';
import {
  openStandaloneTerminalCharge,
  shouldShowStandaloneChargeButton,
} from 'utilities/open-standalone-terminal-charge';
import { openChat } from 'utilities/support-chat';
import { getOrAppendChild } from 'utilities/DOM/getOrAppendChild';
import { track } from 'src/tracking/trackingService';
import _ from 'underscore';

/**
 * Calendar main view.
 */
App.Views.Calendar = BackboneEx.View.Main.extend({
  events: {
    'select.menu #calendar-type-choice': 'onTypeSelect',
    'click .redeem': 'showVoucherRedemptionDialog',
    'click .checkout': 'openNewCheckout',
    'click .a-set-availability': 'showSetAvailabilityDialog',
    'click .a-close-out': 'closeOutSpaDays',
    'click .calendar-resource li': 'onResourceChange',
    'click #keyboard-shortcuts-info': () => {
      App.Views.Calendar.KeyboardShortcuts.show();
    },
    'click #calendar-wl-entries-more': 'showWaitingListEntries',
    'click #calendar-wl-entries-create': 'showWaitingListCreate',
    'click #calendar-wl-entries-close': 'closeWaitingListBanner',
  },

  allTypeClasses: 'type-spa-day type-spa-break type-appointment',
  calendarType: null,
  wizardDone: false,
  animationSpeed: 300,
  navigationInputAccepted: true,
  waitingListBannerClosed: localStorage.getItem('waiting_list_banner_closed') === 'true',

  initialize: function initialize() {
    enableRecording();

    const self = this;
    this.setupOptions();

    App.trigger(Wahanda.Event.CALENDAR_VIEW);

    // Events
    App.on(Wahanda.Event.CALENDAR_ALLOWED_TYPES, (list) => {
      self.checkCurrentCalendarType(list);
    });
    App.on(Wahanda.Event.CALENDAR_DRAWER_CLOSE, () => {
      self.closeCalendarDrawer();
    });
    App.on(Wahanda.Event.CALENDAR_OPEN_APPOINTMENT_MODAL, (data) => {
      self.openCreateAppointmentModal(data, 'calendar/waiting-list');
    });
    App.on(Wahanda.Event.CALENDAR_REFETCH_WAITINGLISTS, () => {
      if (!self.appointmentCalendar.isRendered()) {
        console.error(
          'calendar:refetch-waitinglists event dispatched before appointment-calendar is rendered',
        );
        return;
      }
      let date = self.appointmentCalendar.getDate();
      self.fetchWaitingListEntries(date);
    });
    App.on(Wahanda.Event.CALENDAR_APPOINTMENT_OPEN, ({ appointmentId } = {}) => {
      if (!appointmentId) {
        return;
      }
      const existingModel = self.appointmentCalendar?.calendarObjects?.getAppointment(
        appointmentId,
      );
      App.Views.Forms.Appointment2.openById(appointmentId, undefined, existingModel);
    });
    App.on(Wahanda.Event.CALENDAR_APPOINTMENT_MODAL_CLOSE, () => {
      self.closeAppointmentModal();
    });

    // Appointment calendar + it's subviews
    this.appointmentCalendar = new App.Views.Calendar.AppointmentCalendar({
      el: this.$el,
      options: this.options.options,
      mainView: this,
    });
    // Dated services calendar
    this.datedCalendar = new App.Views.Calendar.DatetableCalendar({
      el: this.$('#dated-calendar'),
      date: this.options.options.initialDate,
      mainView: this,
      closeOutButton: this.$('.close-out-box'),
      initialResourceId: /^spa/.test(this.getCalendarType())
        ? this.options.options.initialResourceId
        : null,
    });
    // Dated month picker
    this.monthPicker = new App.Views.Calendar.MonthPicker({
      el: this.$('#month-calendar'),
      date: this.options.options.initialDate,
    });
    // Appt / spa-day / spa-break select
    this.typeSelector = new App.Views.Calendar.CalendarTypeSelect({
      el: this.$('#calendar-type-choice'),
    });

    this.datedAlertsView = new App.Views.Calendar.DatedAlerts({
      el: this.$('#calendar-alerts'),
    });

    this.hideNonWorkingToggle = new App.Views.Calendar.HideNonWorkingToggle({
      el: this.$('.js-column-collapse-button'),
      options: this.options.options,
      initialCalendarType: this.options.options.initialCalendarType,
      isDayView: this.appointmentCalendar.isDayView.bind(this.appointmentCalendar),
    });

    this.typeSelector.on('rendered', () => {
      // Selects the default type when type selector has finished rendering
      // The "initial" parameter means that this is not a user triggered change
      self.changeType(self.getCalendarType(), { initial: true });
      self.$el.removeClass('loading');
    });

    this._debtWarningBannerProps = {
      onPayClick: () => this.handleDebtPayClick('warning'),
    };
    this._debtBlockedOverlayProps = {
      onPayClick: () => this.handleDebtPayClick('blocked'),
      onContactCxClick: () => this.handleDebtContactCxClick(),
    };

    this.setupShortcuts();

    if (!App.isRestrictedMode()) {
      App.headerView.setModule('calendar');
      // Start calendar refresh timer
      this.setupRefreshTimer();
    }
    this.setupSwipeGestures();

    $('body').addClass('dynamic-allocation');
  },

  setupRefreshTimer: function setupRefreshTimer() {
    const TIMER_NAME = 'calendar-refresh';

    const changeInterval = (intervalType) => {
      App.Timer.cancel(TIMER_NAME);

      const pollingInterval = App.config.getPollingInterval(intervalType) * 60 * 1000;
      App.Timer.start(TIMER_NAME, pollingInterval);
    };

    onWebSocketsStateChange(
      () => changeInterval('pushEnabled'),
      () => changeInterval('default'),
    );

    // Start with the default interval
    changeInterval('default');
  },

  setupOptions: function setupOptions() {
    const opts = _.clone(this.options.options || {});
    // Date configuration
    if (opts.initialDate) {
      try {
        opts.initialDate = Wahanda.Date.createDate(opts.initialDate);
      } catch (e) {
        console.error(e);
      }
    } else {
      opts.initialDate = Wahanda.Date.createVenueDate();
    }
    if (!Wahanda.Date.isValidDate(opts.initialDate)) {
      opts.initialDate = Wahanda.Date.createVenueDate();
    }
    // Initial type
    this.calendarType = opts.initialCalendarType || null;

    this.options.options = opts;

    // Clean data from mainViewOptions
    this.cleanMainViewOptions();
  },

  cleanMainViewOptions: function cleanMainViewOptions() {
    App.mainViewOptions = _.extend(App.mainViewOptions || {}, {
      initialCalendarType: null,
      initialDate: null,
      initialResourceId: null,
    });
  },

  setupSwipeGestures: function setupSwipeGestures() {
    if (!Wahanda.Util.isTouchDevice()) {
      return;
    }

    const $swipeTarget = this.$('.section-main');
    $swipeTarget.swipeArrows({
      scrollElement: '.wc-scrollable-grid',
      onSwipe: (direction) => {
        const event = Wahanda.Event[direction === 'left' ? 'CALENDAR_GO_PREV' : 'CALENDAR_GO_NEXT'];
        App.trigger(event);
        App.trigger(Wahanda.Event.CALENDAR_SWIPE);
      },
    });

    App.on(Wahanda.Event.APPOINTMENT_DRAG_STARTED, () => {
      $swipeTarget.swipeArrows('pause');
    }).on(Wahanda.Event.APPOINTMENT_DRAG_ENDED, () => {
      $swipeTarget.swipeArrows('resume');
    });
  },

  render: function render() {
    this.injectOptionsFromRouter();

    if (!App.config.canSellDated() && this.getCalendarType() !== 'appointment') {
      // Change calendar type to appointment, b/c this venue is in can't sell dated stuff
      this.changeType('appointment');
    }

    this.typeSelector.render();
    this.monthPicker.render();
    if (!App.config.get('venue').pointOfSaleEnabled) {
      this.renderPosLiteSidebarButtons();
    } else {
      this.destroyPosLiteSidebarButtons();
    }
    this.renderIdentityVerificationDialog();
    this.renderDropdowns();
    this.renderStandaloneChargeButton();
    this.renderPOSAdvertisement();
    this.mountDebtBanner();
    this.renderSidebarInfo();
    this.openDialogFromUrl();
    this.openAppointmentModalFromUrl();
    this.openDirectDebitSuccessModalFromUrl();
    App.setUpGoLive();

    let initialDate = this.options.options.initialDate;
    this.fetchWaitingListEntries(initialDate);

    App.on(Wahanda.Event.CALENDAR_DISPLAY_TYPE_CHANGE, ({ type }) => {
      if (!this.appointmentCalendar.isRendered()) {
        console.error(
          'calendar:display-type-change event dispatched before appointment-calendar is rendered',
        );
        return;
      }
      let date = this.appointmentCalendar.getDate();
      this.fetchWaitingListEntries(date, type);
    });

    App.on('calendar:date-change', (date) => {
      if (!this.appointmentCalendar.isRendered()) {
        console.error(
          'calendar:date-change event dispatched before appointment-calendar is rendered',
        );
        return;
      }
      this.fetchWaitingListEntries(date);
    });
  },
  getCurrentTimeSlot() {
    const start = Wahanda.Date.createVenueDate();
    const hour = Wahanda.Date.createVenueDate().getHours();
    start.setHours(hour);
    start.setMinutes(0);
    start.setSeconds(0);
    start.setMilliseconds(0);
    const end = new Date(start.getTime() + 60 * 60 * 1000);

    return {
      start: moment(start).formatHoursMinutes(),
      end: moment(end).formatHoursMinutes(),
    };
  },
  /**
   * Resolves an available employee for the appointment date: prefers data.employeeId,
   * falls back to logged-in employee, then first working employee from the collection.
   */
  resolveEmployeeIdForAppointmentOpen(data) {
    const appointmentDate = data.appointmentDate || this.appointmentCalendar.getDate();
    const fallback = data.employeeId || App.config.getAccountEmployeeId();
    const employeeIds = this.appointmentCalendar.getVisibleResourceIds();
    const resources = this.appointmentCalendar.employeesCollection.getInCalendarFormat();

    const working = App.Models.WorkingHours.getWorkingResources(
      appointmentDate,
      employeeIds,
      resources,
    );

    const isWorking = (id) => id && working.some((r) => r.id === id);

    if (isWorking(data.employeeId)) return data.employeeId;
    if (isWorking(App.config.getAccountEmployeeId())) return App.config.getAccountEmployeeId();

    return working[0]?.id || fallback;
  },

  getSelectedServicesData(serviceOptions, employeeId) {
    return serviceOptions.map((service) => {
      const duration = service.serviceOptionDuration.value;
      const finishingTime = service.finishingTimeMins;
      const processingTime = service.processingTimeMins;
      const cleanupTime = service.cleanUpDuration.value || 0;

      const totalDuration = [duration, finishingTime, processingTime, cleanupTime]
        .filter((t) => !!t)
        .reduce((sum, time) => sum + time, 0);

      let employee = {
        employeeId: App.config.getAccountEmployeeId(),
        name: App.config.accountEmployeeName(),
      };

      if (employeeId) {
        employee = {
          employeeId: employeeId,
          name: this.appointmentCalendar.employeesCollection.get(employeeId)?.get('name') || '',
        };
      }

      return {
        serviceId: service.serviceId,
        skus: [
          {
            serviceId: service.serviceId,
            skuId: service.optionId,
            skuName: service.name,
            skuCategory: service.pricingLevel,
            duration,
            totalDuration,
            finishingTime,
            applicationTime: duration,
            processingTime,
            price: service.price.amount,
            employee,
          },
        ],
        cleanupTime,
        type: 'service',
        name: service.serviceName,
      };
    });
  },
  openCreateAppointmentModal(data, source) {
    const createModel = (option, index) =>
      new App.Models.Appointment({
        appointmentDate: data.appointmentDate,
        consumerEmail: data.venueCustomer.emailAddress,
        consumerId: data.venueCustomer.id,
        consumerName: data.venueCustomer.name,
        consumerPhone: data.venueCustomer.phone,
        endTime: option ? option.endTime : data.endTime,
        offerId: option ? option.serviceId : null,
        skus: option ? [{ skuId: option.optionId }] : [],
        startTime: option ? option.startTime : data.startTime,
        waitingListId: option ? index + 1 : null,
        venueId: data.venueId,
        venueCustomerId: data.venueCustomer.id,
        employeeId: data.employeeId,
      });
    const models = data.serviceOptions.length
      ? data.serviceOptions.map((option, index) => createModel(option, index))
      : [createModel()];

    const customerData = data.venueCustomer;
    const appointments = new BackboneEx.Collection.Base(null, {
      model: App.Models.Appointment,
    });

    appointments.reset(models);

    if (Wahanda.Features.isEnabled('THY-314-new-add-appointment-drawer')) {
      const resolvedEmployeeId = this.resolveEmployeeIdForAppointmentOpen(data);
      const defaultTimeSlot = this.getCurrentTimeSlot();
      const services = this.getSelectedServicesData(data.serviceOptions, resolvedEmployeeId);
      this.mountNewTimeSlot(
        {
          date: data.appointmentDate,
          time: data.startTime || defaultTimeSlot.start,
          endTime: data.endTime || defaultTimeSlot.end,
          customer: customerData,
          services,
          employeeId: resolvedEmployeeId,
          note: data.notes,
        },
        source,
      );
      return;
    }

    App.ES6.Initializers.State.change({
      'calendar-event-editor': {
        appointmentViewData: {
          model: models[0],
          initialCollectionStructure: { appointments: appointments.toJSON() },
        },
        tab: 'appointment',
        customerData,
      },
    });
  },
  fetchWaitingListEntries(date, type) {
    const venueId = App.getVenueId();
    let fromDate = date || this.appointmentCalendar.getDate();
    let toDate = null;
    let dayView = type === 'day' || this.appointmentCalendar.isDayView();

    if (!dayView) {
      fromDate = moment(fromDate).startOf('isoWeek').formatApiDateString();
      toDate = moment(date).endOf('isoWeek').formatApiDateString();
      if (moment(fromDate).isSame(moment(toDate), 'day')) {
        toDate = null;
      }
    }

    if (!fromDate || !venueId) {
      console.error(
        'calendar:fetch-waiting-list-entries() no fromDate or venueId which are required parameters',
      );
      return;
    }

    let endpoint = `/api/calendar/venue/${venueId}/waiting-list-entry`;

    if (fromDate && toDate === null) {
      endpoint += `?date=${Wahanda.Date.toApiString(fromDate)}`;
    } else if (fromDate && toDate) {
      endpoint += `?startDate=${fromDate}&endDate=${toDate}`;
    }

    fetch(endpoint)
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            console.error('calendar:fetch-waiting-list-entries() unauthorized');
            return;
          }

          throw new Error('Error fetching waiting list entries');
        }

        return response.json();
      })
      .then((data) => {
        const count = data.length;

        if (count) {
          this.$('#calendar-waiting-list-amount').text(
            count === 1
              ? Wahanda.lang.calendar.waitingList.oneRegistration.replace('{{count}}', count)
              : Wahanda.lang.calendar.waitingList.moreRegistrations.replace('{{count}}', count),
          );
        } else {
          this.$('#calendar-waiting-list-amount').text(
            Wahanda.lang.calendar.waitingList.noRegistrations,
          );
        }

        this.$('#calendar-wl-entries-more').toggleClass('hidden', count === 0);
        this.$('#calendar-wl-entries-create').toggleClass('hidden', count > 0);
        this.$('#calendar-wl-entries-close').toggleClass('hidden', count > 0);

        this.$('.calendar-pane').toggleClass(
          'has-waiting-list',
          !(this.waitingListBannerClosed && count === 0),
        );
      });
  },
  closeWaitingListBanner() {
    this.waitingListBannerClosed = true;
    localStorage.setItem('waiting_list_banner_closed', 'true');
    this.$('.calendar-pane').removeClass('has-waiting-list');
  },
  showWaitingListEntries() {
    this.showWaitingList('overview');
  },
  showWaitingListCreate() {
    this.showWaitingList('create');
  },
  showWaitingList(initialPage) {
    this.mountWaitingList(initialPage);
  },
  closeCalendarDrawer() {
    this.unmountCalendarDrawer();
  },
  closeAppointmentModal() {
    // Close only the CalendarEventEditor modal (appointment modal)
    App.ES6.Initializers.State.change({
      'calendar-event-editor': null,
    });
  },
  mountNewTimeSlot(data, source) {
    App.ES6.Initializers.NewTimeSlot({
      type: 'appointment',
      data,
      source,
    }).render();
    if (Wahanda.Features.isEnabled('THY-record-add-appointment-drawer-session')) {
      Wahanda.SessionReplay.startRecording();
    }
  },
  mountWaitingList(initialPage) {
    const initialDate = Wahanda.Date.formatToApiFullDate(this.appointmentCalendar.getDate()).date;
    App.ES6.Initializers.WaitingList({
      initialPage,
      initialDate,
    }).render();
  },
  unmountCalendarDrawer() {
    const node = document.getElementById('calendar-drawer-container');
    if (node) {
      ReactDOM.unmountComponentAtNode(node);
    }
    if (
      Wahanda.Features.isEnabled('THY-record-add-appointment-drawer-session') &&
      Wahanda.Features.isEnabled('THY-314-new-add-appointment-drawer')
    ) {
      Wahanda.SessionReplay.stopRecording();
    }
  },
  renderIdentityVerificationDialog: function renderIdentityVerificationDialog() {
    const isNotKycNeeded = !App.isIdentityVerificationNeeded();
    const isSelfOnboarding = App.isSelfOnboarding();
    const hasNotElapsedDay = !this.hasIdentityVerificationElapsedDay();

    // Self onboarding already has a KYC step
    if (isNotKycNeeded || hasNotElapsedDay || isSelfOnboarding) {
      return;
    }

    this.setIdentityVerificationLastShownDate();

    App.ES6.Initializers.IdentityVerificationModal({
      isKycNewSupplier: App.isKycNewSupplier(),
      node: this.$('.identity-verification-dialog')[0],
    }).render({});
  },
  setIdentityVerificationLastShownDate: () => {
    const isTestEnvironment = App.env === 'TEST';
    if (isTestEnvironment) {
      return;
    }

    const now = moment().startOf('day');
    Wahanda.LocalStorage.set(
      'calendar.identityVerification.lastShownDate',
      now.valueOf().toString(),
    );
  },
  hasIdentityVerificationElapsedDay: () => {
    const lastShownDateStr = Wahanda.LocalStorage.get(
      'calendar.identityVerification.lastShownDate',
    );
    const lastShownDate = moment(+lastShownDateStr ?? 0);
    const now = moment().startOf('day');
    const hasElapsedDay = lastShownDate.startOf('day').diff(now, 'days') !== 0;

    return hasElapsedDay;
  },
  createCurrentCalEvent: function createCurrentCalEvent() {
    const apptCalendar = this.appointmentCalendar;
    const now = App.ES6.moment.venueTimeZoneDate();
    const blockStart = App.ES6.moment(this.appointmentCalendar.getDate());

    // Use the Calendar's date, but current time.
    blockStart.hour(now.hour());
    // Align to 5 minute time grid
    blockStart.minutes(now.minutes() - (now.minutes() % 5));

    return {
      start: blockStart.toDate(),
      end: App.ES6.moment(blockStart).add(1, 'hour').toDate(),
      rid: apptCalendar.isDayView() ? null : this.appointmentCalendar.getDefaultResourceId(),
    };
  },

  startMultipleBlocking: function startMultipleBlocking() {
    const enterBlockoutMode = function () {
      this.navigationInputAccepted = false;
      this.appointmentCalendar.enterBlockoutMode();
    }.bind(this);
    const exitBlockoutMode = function () {
      this.navigationInputAccepted = true;
      this.appointmentCalendar.leaveBlockoutMode();
    }.bind(this);

    App.ES6.Initializers.State.change({
      'multi-blockout-mode': {
        onClose: function (data) {
          exitBlockoutMode();

          if (data && data.saved > 0) {
            this.appointmentCalendar.refreshMainCalendar();
            App.trigger(Wahanda.Event.CALENDAR_MULTIPLE_BLOCKS_SAVED, {
              count: data.count,
              savedIds: data.savedIds,
            });
          } else {
            App.trigger(Wahanda.Event.CALENDAR_MULTIPLE_BLOCKS_CANCEL);
          }
        }.bind(this),
        getBlockedValues: function () {
          return this.appointmentCalendar.getBlockoutEvents();
        }.bind(this),
        toggleSpinner: function (show) {
          const method = show ? 'showLoader' : 'hideLoader';

          this.appointmentCalendar[method]();
        }.bind(this),
      },
    });

    enterBlockoutMode();
    App.trigger(Wahanda.Event.CALENDAR_MULTIPLE_BLOCKS_OPENED);
  },

  prepareForFloatingEventMode() {
    this.floatingEventMode = true;
    this.$('#keyboard-shortcuts-info').wHide();
    this.$('#sidebar-info').wHide();
    this.$('.calendar-buttons, #calendar-alerts, #calendar-type-choice').addClass(
      'reschedule-mode',
    );
  },

  exitFloatingEventMode() {
    this.floatingEventMode = false;
    this.$('#keyboard-shortcuts-info').wShow();
    this.$('#sidebar-info').wShow();
    this.$('.calendar-buttons, #calendar-alerts, #calendar-type-choice').removeClass(
      'reschedule-mode',
    );
  },

  startReschedulingMode(itemList, data) {
    this.prepareForFloatingEventMode();
    this.appointmentCalendar.startReschedulingMode(itemList, data);
  },

  startRebookingMode(dayCollection, data) {
    this.prepareForFloatingEventMode();
    this.appointmentCalendar.startRebookingMode(dayCollection, data);
  },

  renderPosLiteSidebarButtons() {
    const node = this.$('.calendar-react-buttons')[0];

    App.ES6.Initializers.CheckoutButton({
      node,
      onCheckoutButtonClick: () => {
        CalendarAnalytics.trackPosLiteStandaloneProductCheckoutClick();
        if (
          Wahanda.Features.isEnabled('TEF-2035-new-checkout-flow') &&
          Wahanda.Features.isEnabled('TEF-4130-lite-checkout')
        ) {
          openInstantSaleCheckout({ isLiteCheckoutEnabled: true });
          return;
        }
        const dialog = new App.Views.Forms.POSDialogLite();
        dialog.render();
        dialog.disablePOSSubmit();
        dialog.open();
      },
    }).render();
  },

  destroyPosLiteSidebarButtons() {
    const node = this.$('.calendar-react-buttons')[0];
    App.ES6.Initializers.CheckoutButton({ node }).destroy();
  },

  renderStandaloneChargeButton() {
    const node = getOrAppendChild({
      id: 'calendar-standalone-charge-button',
      parentNode: document.body,
    });

    if (shouldShowStandaloneChargeButton()) {
      ReactDOM.render(
        <Reconnect
          name="StandaloneChargeButton"
          props={{
            onClick: openStandaloneTerminalCharge,
            testID: 'calendar-standalone-charge-button',
            venueId: App.getVenueId(),
          }}
        />,
        node,
      );
    } else {
      ReactDOM.unmountComponentAtNode(node);
    }
  },

  destroyStandaloneChargeButton() {
    const node = document.getElementById('calendar-standalone-charge-button');
    if (node) {
      ReactDOM.unmountComponentAtNode(node);
    }
  },

  renderDropdowns() {
    const self = this;
    const node = this.$('.calendar-react-dropdowns')[0];

    if (this.getCalendarType() === 'appointment') {
      const apptButtonAllowed = this.appointmentCalendar.getCanShowAddAppointmentButton();

      App.ES6.Initializers.CalendarDropdowns.initialize(node, {
        addActions: {
          addAppointment: apptButtonAllowed
            ? function () {
                self.appointmentCalendar.openAddAppointmentDialog();
              }
            : null,
          addBlock() {
            // The param is a mock calEvent object
            self.appointmentCalendar.showBlockAddDialog(self.createCurrentCalEvent());
          },
          startMultipleBlocking: this.startMultipleBlocking.bind(this),
          redeemEvoucher() {
            self.appointmentCalendar.showUseEvoucherDialog(self.createCurrentCalEvent());
          },
          addWaitingList() {
            self.showWaitingList('create');
          },
        },
      });
    } else {
      App.ES6.ReactDOM.unmountComponentAtNode(node);
    }
  },

  // debtSource distinguishes the two shared-handler callers so the checkout return
  // (useDebtBlockedTracking) can attribute the payment to the right cohort.
  handleDebtPayClick(debtSource) {
    const supplierId = App.getSupplierId();
    const showFetchError = () =>
      Wahanda.ToastNotifications.sendMessage('Something went wrong, please contact support.', {
        variant: 'danger',
      });
    // Falls back to the current URL if it can't be parsed, rather than losing the flow.
    const buildRedirectUrl = (param) => {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set(param, 'true');
        url.searchParams.set('debtSource', debtSource);
        return url.toString();
      } catch {
        return window.location.href;
      }
    };
    const remittances = new App.Collections.Remittances();
    Promise.resolve(remittances.fetch())
      .then(() => {
        // Same selection as the Settings "outstanding balance" note.
        const lastRemittance = remittances.models.find(
          (remittance) => remittance.isPast() && remittance.get('closingBalance'),
        );
        if (!lastRemittance) {
          throw new Error('No payable remittance found for this supplier');
        }
        return fetch(
          `/api/finance/supplier/${supplierId}/invoice/${lastRemittance.get('id')}/checkout-url`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              successUrl: buildRedirectUrl('success'),
              cancelUrl: buildRedirectUrl('canceled'),
            }),
          },
        );
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Something went wrong creating the checkout session');
        }
        // /checkout-url returns the URL as plain text, not JSON.
        return response.text();
      })
      .then((redirectUrl) => {
        const target = new URL(redirectUrl);
        if (target.protocol !== 'https:') {
          throw new Error('Invalid redirect URL protocol');
        }
        window.location.assign(target.toString());
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Failed to initiate debt payment checkout', error);
        showFetchError();
        track('payments.debt.checkout_url.failed', {
          debt_source: debtSource,
          reason: error && error.message ? error.message : 'unknown',
        });
      });
  },

  handleDebtContactCxClick() {
    openChat('debt blocked overlay');
  },

  // Debt-recovery warning banner (PAYB2B-530) + blocked overlay (PAYB2B-531).
  // Both self-gate (render null) until the partner is at-risk/blocked.
  // Mounted on Calendar (landing screen).
  mountDebtBanner() {
    // render() re-runs this on every date/nav change; tear down the previous
    // observer/listener first so they don't accumulate across re-renders.
    if (this._debtBannerResizeObserver) {
      this._debtBannerResizeObserver.disconnect();
      this._debtBannerResizeObserver = null;
    }
    if (this._debtBannerResizeHandler) {
      window.removeEventListener('resize', this._debtBannerResizeHandler);
      this._debtBannerResizeHandler = null;
    }
    if (this._debtBannerSyncTimeout) {
      clearTimeout(this._debtBannerSyncTimeout);
      this._debtBannerSyncTimeout = null;
    }

    const bannerNode = this.$('#calendar-debt-banner-container').get(0);
    if (bannerNode) {
      ReactDOM.render(
        <Reconnect name="DebtWarningBanner" props={this._debtWarningBannerProps} />,
        bannerNode,
      );
      // The calendar grid (.calendar) is absolutely positioned and ignores the
      // banner in normal flow, so it would overlap the banner's bottom. Push the
      // grid down by the banner's rendered height (0 when no banner is shown).
      const syncOffset = () => {
        const grid = document.querySelector('.wc-container');
        const cal = grid && grid.offsetParent;
        if (cal) cal.style.marginTop = `${bannerNode.offsetHeight}px`;
      };
      // .wc-container is rebuilt asynchronously by the legacy resourcecalendar
      // plugin (it waits on its own appointments/resources fetch) and may not
      // exist yet when the banner first mounts, independently of how long the
      // banner's own async chain takes. Retry with exponential backoff until
      // it does, then hand off to the ResizeObserver/resize listener below
      // for subsequent changes.
      const SYNC_BACKOFF_START_MS = 100;
      const SYNC_BACKOFF_MAX_MS = 4000;
      const SYNC_TOTAL_TIMEOUT_MS = 30000;
      let syncBackoffMs = SYNC_BACKOFF_START_MS;
      let syncElapsedMs = 0;
      const trySyncUntilGridExists = () => {
        const grid = document.querySelector('.wc-container');
        if (grid && grid.offsetParent) {
          syncOffset();
          return;
        }
        if (syncElapsedMs >= SYNC_TOTAL_TIMEOUT_MS) {
          return;
        }
        this._debtBannerSyncTimeout = setTimeout(trySyncUntilGridExists, syncBackoffMs);
        syncElapsedMs += syncBackoffMs;
        syncBackoffMs = Math.min(syncBackoffMs * 2, SYNC_BACKOFF_MAX_MS);
      };
      trySyncUntilGridExists();

      if (window.ResizeObserver) {
        this._debtBannerResizeObserver = new ResizeObserver(syncOffset);
        this._debtBannerResizeObserver.observe(bannerNode);
      } else {
        syncOffset();
      }
      this._debtBannerResizeHandler = syncOffset;
      window.addEventListener('resize', syncOffset);
    }

    let overlayNode = document.getElementById('debt-blocked-overlay-container');
    if (!overlayNode) {
      overlayNode = document.createElement('div');
      overlayNode.id = 'debt-blocked-overlay-container';
      document.body.appendChild(overlayNode);
    }
    ReactDOM.render(
      <Reconnect name="DebtBlockedOverlay" props={this._debtBlockedOverlayProps} />,
      overlayNode,
    );
  },

  renderPOSAdvertisement() {
    const venueChannelCode = App.config.get('venue').contentChannelCode;
    const countriesThatHavePOSEnabled = [
      channelCodes.BE,
      channelCodes.CH,
      channelCodes.DE,
      channelCodes.ES,
      channelCodes.GB,
      channelCodes.IE,
      channelCodes.IT,
      channelCodes.NL,
    ];
    const countriesThatWillHavePOSEnabledSoon = [channelCodes.FR, channelCodes.AT];

    const venueCanHavePosEnabled = [
      ...countriesThatHavePOSEnabled,
      ...countriesThatWillHavePOSEnabledSoon,
    ].some((channelCode) => channelCode === venueChannelCode);
    const showPOSAd = !App.config.get('venue').pointOfSaleEnabled && venueCanHavePosEnabled;
    const wrapperDOM = this.$('#pos-ad');
    if (!showPOSAd) {
      wrapperDOM.wHide();
      return;
    }
    const canHavePOSInCountry = countriesThatHavePOSEnabled.some(
      (country) => country === venueChannelCode,
    );
    wrapperDOM.wShow();

    if (App.config.get('venue').listedOnMarketplace) {
      wrapperDOM.html(
        Wahanda.Template.renderTemplate('looking-for-pos', {
          canHavePOSInCountry,
        }),
      );
      this.$('.js-pos-ad-link-info').click(CalendarAnalytics.trackLookingForPOSClick);
    }
  },

  renderSidebarInfo() {
    const sidebarInfoNode = this.$('#sidebar-info').get(0);
    App.ES6.Initializers.SidebarInfo({
      node: sidebarInfoNode,
      liveChatSource: 'calendar sidebar',
    }).render();
  },

  injectOptionsFromRouter() {
    const options = App.mainViewOptions || {};

    if (options.initialDate) {
      try {
        const date = Wahanda.Date.createDate(options.initialDate);
        App.trigger('calendar:date-change', date);
      } catch (e) {
        console.error(e);
      }
    }
    if (options.initialCalendarType) {
      this.changeType(options.initialCalendarType);
    }

    this.cleanMainViewOptions();
  },

  renderPaneView() {
    this.appointmentCalendar.headerPaneView.render();
  },

  renderResources() {
    const paneView = this.appointmentCalendar.headerPaneView;
    paneView.renderResources.apply(paneView, arguments);
  },

  changeType(type, options) {
    const previousTypeTheSame = this.calendarType === type;
    this.calendarType = type;
    this.typeSelector.setCurrentByType(type);
    this.storeCalendarType(type);
    App.Timer.reset('calendar-refresh');
    // Set the visible view's class
    this.$el.removeClass(this.allTypeClasses).addClass(`type-${type}`);
    App.trigger(
      Wahanda.Event.CALENDAR_TYPE_CHANGE,
      type,
      _.extend({ previousTypeTheSame }, options),
    );
  },

  getCalendarType() {
    if (this.calendarType) {
      return this.calendarType;
    }

    let type = this.getStoredCalendarType();
    if (!type) {
      type = 'appointment';
    }
    return type;
  },

  getActiveCalendarView() {
    if (this.getCalendarType() === 'appointment') {
      return this.appointmentCalendar;
    }
    return this.datedCalendar;
  },

  getStoredCalendarType() {
    const types = Wahanda.LocalStorage.get('calendar-type') || [];
    const venueId = App.getVenueId();

    const match = _.find(types, function (item) {
      return item.venueId === venueId;
    });

    return match ? match.type : null;
  },

  storeCalendarType(type) {
    const venueId = App.getVenueId();
    let newTypes = _.filter(Wahanda.LocalStorage.get('calendar-type') || [], function (item) {
      return item.venueId !== venueId;
    });

    newTypes.push({
      venueId,
      type,
    });

    // We don't want to store data for more than 5 venues
    if (newTypes.length > 5) {
      newTypes = newTypes.slice(newTypes.length - 5);
    }

    Wahanda.LocalStorage.set('calendar-type', newTypes);
  },

  // Events
  onTypeSelect(event, node) {
    const type = $(node).data('type');
    trackEvent('calendar', 'edit', 'type', type);

    this.changeType(type);
  },

  showVoucherRedemptionDialog(options) {
    App.Views.Calendar.VoucherRedemption.open(options);
  },

  openNewCheckout() {
    const dialog = new App.Views.Forms.POSDialog();
    dialog.render();
    dialog.open();
  },

  showSetAvailabilityDialog() {
    trackEvent('calendar', 'click', 'add-inventory');

    if (this.datedCalendar.isActive()) {
      this.datedCalendar.showSetAvailabilityDialog();
    }
  },

  closeOutSpaDays() {
    if (this.datedCalendar.isActive()) {
      this.datedCalendar.showCloseOutDaysDialog();
    }
  },

  onResourceChange(event) {
    App.trigger(Wahanda.Event.CALENDAR_RESOURCE_CHANGE, $(event.currentTarget).attr('id'));
  },

  // Main view URL hash functions
  /**
   * Updates the URL to the current state.
   */
  updateUrlWithCurrentOptions() {
    return this.getActiveCalendarView().updateUrlWithCurrentOptions();
  },

  getCurrentStateHash() {
    return this.getActiveCalendarView().getCurrentStateHash();
  },

  // Shortcuts

  setupShortcuts() {
    const onlyIfInputAccepted = function (fn) {
      return function () {
        if (this.navigationInputAccepted) {
          fn.apply(null, arguments);
        }
      }.bind(this);
    }.bind(this);

    const addShortcut = function (key, handlerFn) {
      Wahanda.Shortcuts.add(key, onlyIfInputAccepted(handlerFn.bind(this)));
    }.bind(this);

    const changeTypeToDay = function () {
      this.appointmentCalendar.trigger('change:type', 'day');
    }.bind(this);

    // Reload venue
    addShortcut('space', function () {
      App.trigger(Wahanda.Event.CALENDAR_REQUEST_REFRESH);
    });
    // Go to TODAY view
    addShortcut('backspace', function () {
      changeTypeToDay();
      App.trigger(Wahanda.Event.CALENDAR_GO_TODAY);
    });
    // Go back in calendar
    addShortcut('left', function () {
      App.trigger(Wahanda.Event.CALENDAR_GO_PREV);
    });
    // Go forward
    addShortcut('right', function () {
      App.trigger(Wahanda.Event.CALENDAR_GO_NEXT);
    });

    // 1..9 numbers changing resourceIds
    const numberHandler = function (event) {
      const resourcePosition = parseInt(String.fromCharCode(event.keyCode), 10);
      App.trigger('calendar:request-resource-view', resourcePosition);
    };

    for (let num = 1; num <= 10; num++) {
      addShortcut(String(num), numberHandler);
    }

    // Got to day view
    addShortcut('0', changeTypeToDay);

    const onlyIfAppointmentCalendar = function (fn) {
      return function () {
        if (this.getCalendarType() === 'appointment' && !this.floatingEventMode) {
          fn.call(this);
        }
      }.bind(this);
    }.bind(this);

    // New appointment. Only in Appointment mode.
    addShortcut(
      'a',
      onlyIfAppointmentCalendar(function () {
        this.getActiveCalendarView().openAddAppointmentDialog();
      }),
    );

    // New Block
    addShortcut(
      'b',
      onlyIfAppointmentCalendar(function () {
        this.appointmentCalendar.showBlockAddDialog(this.createCurrentCalEvent());
      }),
    );

    // Blockout mode
    addShortcut('m', onlyIfAppointmentCalendar(this.startMultipleBlocking));

    // Standalone checkout
    addShortcut(
      'c',
      onlyIfAppointmentCalendar(function () {
        if (App.config.get('venue').pointOfSaleEnabled) {
          this.openNewCheckout();
        }
      }),
    );

    // There are also some global shortcuts in `Wahanda.Shortcuts`.
  },

  lightweightAuthAction() {
    // We're in LightweightAuth mode. Probably will confirm an appointment.
    // Don't try refreshing after, as that will call out errors about calendar not yet initialized.
    this.appointmentCalendar.allowRefresh = false;
    this.openLightweightModeDialog();
    this.openDialogFromUrl();
  },

  openDialogFromUrl() {
    if (this.hasUrlDialog()) {
      const dialog = App.mainViewOptions.initialDialog;
      // Open dialogs from URL
      if (dialog.type === 'appointment' || dialog.type === 'appointment-order') {
        this.openAppointmentDialogFromUrl(dialog.type);
      }
      if (dialog.type === 'order') {
        this.openOrderDialogFromUrl();
      } else if (dialog.type === 'booking') {
        if (dialog.action === 'reject') {
          this.openBookingRejectionForm(dialog.id);
        } else {
          this.openBookingDialog(dialog.id);
        }
        delete App.mainViewOptions.initialDialog;
      }
    }
  },

  openAppointmentModalFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const shouldOpenModal = urlParams.get('openAppointmentModal');
    const appointmentDataParam = urlParams.get('appointmentData');

    if (shouldOpenModal === 'true' && appointmentDataParam) {
      try {
        const appointmentData = JSON.parse(appointmentDataParam);

        // Wait for the calendar to be rendered before opening the modal
        Wahanda.Util.waitUntil(
          () => this.appointmentCalendar.rendered,
          () => {
            this.openCreateAppointmentModal(appointmentData, 'clients/overview');
            // Clean up the URL parameters
            const newUrl = new URL(window.location);
            newUrl.searchParams.delete('openAppointmentModal');
            newUrl.searchParams.delete('appointmentData');
            window.history.replaceState({}, '', newUrl.toString());
          },
        );
      } catch (error) {
        console.error('Failed to parse appointment data from URL:', error);
      }
    }
  },

  // Shows the DD success modal when the calendar is opened with ?dd-enabled=1,
  // then strips the param so a refresh cannot re-open it.
  openDirectDebitSuccessModalFromUrl() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('dd-enabled') !== '1') return;

    const url = new URL(window.location);
    url.searchParams.delete('dd-enabled');
    window.history.replaceState({}, '', url.toString());

    const node = getOrAppendChild({ id: 'dd-success-modal', parentNode: document.body });
    ReactDOM.render(
      <Reconnect
        name="DirectDebitSuccessModal"
        props={{ onDismiss: () => ReactDOM.unmountComponentAtNode(node) }}
      />,
      node,
    );
  },

  openAppointmentDialogFromUrl(type) {
    const self = this;
    const dialog = App.mainViewOptions.initialDialog;
    // If this is restricted mode, some models should be fetched separately
    let modelsLoaded = true;
    let orderLoaded = true;
    const models = [this.appointmentCalendar.model, this.appointmentCalendar.employeesCollection];
    let apptId = dialog.id;
    let apptGroupId;
    let orderToOpen;

    if (App.isRestrictedMode()) {
      modelsLoaded = false;
      self.appointmentCalendar.model.set('venueId', App.getVenueId());
      BackboneEx.Tool.MultiModelFetch.run(models, function () {
        modelsLoaded = true;
      });
    }
    if (type === 'appointment-order') {
      orderLoaded = false;
      const order = new App.Models.Order({ id: dialog.id });
      order.fetch().done(function () {
        const group = order.getPackageGroup();
        if (group) {
          apptGroupId = group.id;
          apptId = group.at(0).id;
        } else {
          // An order with no groups, probably either a single-appt order or already confirmed.
          orderToOpen = order;
        }
        if (dialog.action === 'confirm') {
          const onConfirmation = function () {
            orderLoaded = true;
            // Don't need to try to confirm the Appointment separately
            dialog.action = 'none';
          };
          let confirmTarget;

          if (group) {
            confirmTarget = group;
          } else if (order.isAppointment()) {
            confirmTarget = order.getAppointments()[0];
          } else {
            confirmTarget = order;
          }

          if (typeof confirmTarget.isUnconfirmed === 'function' && !confirmTarget.isUnconfirmed()) {
            // Appointment/ApptGroup already confirmed
            onConfirmation();
            return;
          }

          confirmTarget.confirm().done(onConfirmation);
        } else {
          orderLoaded = true;
        }
      });
    }
    // Doing this async, when the calendar or models are loaded
    Wahanda.Util.waitUntil(
      function () {
        return (
          orderLoaded &&
          ((App.isRestrictedMode() && modelsLoaded) || self.appointmentCalendar.rendered)
        );
      },
      function () {
        if (dialog.action === 'reject') {
          if (type === 'appointment-order') {
            self.appointmentCalendar.showAppointmentGroupRejectionForm(apptGroupId);
          } else {
            self.appointmentCalendar.showAppointmentRejectionForm(dialog.id);
          }
        } else if (orderToOpen) {
          self.appointmentCalendar.showAppointmentFromOrder(orderToOpen);
        } else {
          self.appointmentCalendar.showAppointmentFromUrl(apptId || dialog.id);
        }
        delete App.mainViewOptions.initialDialog;
      },
    );
  },

  openOrderDialogFromUrl() {
    const dialog = App.mainViewOptions.initialDialog;

    App.Views.Dialog.Order2.openById(dialog.id);

    delete App.mainViewOptions.initialDialog;
  },

  openAppointment(appointmentId) {
    this.appointmentCalendar.showAppointment(appointmentId);
  },

  hasUrlDialog() {
    return App.mainViewOptions && App.mainViewOptions.initialDialog;
  },

  openBookingDialog(bookingId) {
    const view = new App.Views.Dialog.Booking({
      model: new App.Models.Booking({
        id: bookingId,
        venueId: App.config.get('venue').id,
      }),
    });
    view.render();
    view.open();
  },

  openBookingRejectionForm(id) {
    const model = new App.Models.Booking({
      id,
      venueId: App.getVenueId(),
    });

    const openRejectionForm = function () {
      const form = new App.Views.Dialog.Booking.Rejection({
        model,
      });
      form.render();
      form.open();
    };

    model.fetch({
      success: openRejectionForm,
      error: BackboneEx.Tool.ModelLightweightFetch({
        onSuccess: openRejectionForm,
        onError: App.Views.Calendar.NoPermission.open,
      }),
      skipErrorHandling: true,
    });
  },

  checkCurrentCalendarType(allowed) {
    const current = this.getCalendarType();
    if (_.indexOf(allowed, current) === -1) {
      // Current visible type is not in the allowed types. Change to the first allowed.
      // Calendar should be rendered after this callback. Note the current flow!
      this.calendarType = allowed[0];
    }
  },

  remove: function remove() {
    if (this._debtBannerResizeObserver) {
      this._debtBannerResizeObserver.disconnect();
      this._debtBannerResizeObserver = null;
    }
    if (this._debtBannerResizeHandler) {
      window.removeEventListener('resize', this._debtBannerResizeHandler);
      this._debtBannerResizeHandler = null;
    }
    if (this._debtBannerSyncTimeout) {
      clearTimeout(this._debtBannerSyncTimeout);
      this._debtBannerSyncTimeout = null;
    }
    // Body-appended (like the debt banner nodes above), so it outlives a
    // plain DOM removal of this.el and needs an explicit unmount.
    this.destroyStandaloneChargeButton();
    return BackboneEx.View.Main.prototype.remove.call(this);
  },
});

App.Views.Calendar.Appointment = {};
App.Views.Calendar.Dated = {};
